import { instance } from "@/api/index";

// 지출결의 CRUD
export const listDsbr = () => instance.get("/back/cashDsbr");
export const setDsbr = payload => instance.post("/back/cashDsbr", payload);
export const detailDsbr = payload => instance.get(`/back/cashDsbr/${payload}`);
export const modyDsbr = (cashDsbrVchNo, payload) =>
  instance.put(`/back/cashDsbr/${cashDsbrVchNo}`, payload);
export const delDsbr = payload => instance.delete(`/back/cashDsbr/${payload}`);

// 결재
export const approvalDsbr = (cashDsbrVchNo, payload) =>
  instance.post(`/back/cashDsbr/${cashDsbrVchNo}`, payload);
